// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hChYpzFshATQo8 {
  display: inline-block;
  line-height: 1;
}
.D6VmBk1nhYjP6x svg {
  width: 14px;
  height: 14px;
  line-height: 14px;
}
.GzZMAuibTh5l1i svg {
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.FQRfhpoLVAyxHI svg {
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.hvjX7mk6fQFbYh svg {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.w4FNArtttu7hBq {
  box-sizing: border-box;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 3px 3px;
}
.Ze9ghgNnzJ_xri {
  box-sizing: border-box;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 2px 2px;
}
.oVGj_rb8YD7NrA {
  box-sizing: border-box;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 6px 6px;
}
.UBbjU_rUkEdrAQ {
  box-sizing: border-box;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 4px 4px;
}
`, ""]);
// Exports
var _1 = `hChYpzFshATQo8`;
export { _1 as "nch-icon" };
var _2 = `D6VmBk1nhYjP6x`;
export { _2 as "nch-icon--xsmall" };
var _3 = `GzZMAuibTh5l1i`;
export { _3 as "nch-icon--small" };
var _4 = `FQRfhpoLVAyxHI`;
export { _4 as "nch-icon--medium" };
var _5 = `hvjX7mk6fQFbYh`;
export { _5 as "nch-icon--large" };
var _6 = `w4FNArtttu7hBq`;
export { _6 as "nch-icon--xsmall-block" };
var _7 = `Ze9ghgNnzJ_xri`;
export { _7 as "nch-icon--small-block" };
var _8 = `oVGj_rb8YD7NrA`;
export { _8 as "nch-icon--medium-block" };
var _9 = `UBbjU_rUkEdrAQ`;
export { _9 as "nch-icon--large-block" };
export default ___CSS_LOADER_EXPORT___;
